import IconCheck from "lib/assets/check.svg";

export const PremiumPlan = () => {
  return (
    <div
      css={`
        padding: 0 20px;

        @media (min-width: 960px) {
          padding: 0;
        }
      `}
    >
      <div
        css={`
          border-radius: 20px;
          padding: 30px 20px 36px;
          background-color: white;

          @media (min-width: 960px) {
            border-radius: 0;
            padding: 45px;
          }
        `}
      >
        <Heading />
        <Features />
      </div>
    </div>
  );
};

const Heading = () => {
  return (
    <div
      css={`
        margin-bottom: 30px;
        line-height: 28px;
        font-size: 20px;
        font-weight: 600;
        font-family: "Pretendard", sans-serif;
      `}
    >
      <span
        css={`
          background: linear-gradient(90deg, #7400ff 0%, #325aff 100%);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        `}
      >
        Premium Plan
      </span>
    </div>
  );
};

const Features = () => {
  return (
    <div
      css={`
        display: flex;
        flex-direction: column;
        gap: 20px;
      `}
    >
      <Feature description="Real-time tracking for USCIS, NVC, DOL, and EOIR" />
      <Feature description="Automated email notifications for case updates" />
      <Feature description="Visualization for processing time and visa bulletin trends" />
      <Feature description="Bulk case upload for streamlined processing" />
      <Feature description="Client portal for real-time case updates" />
      <Feature description="Email integrations for efficient client communication" />
      <Feature description="Documents (I-797 or Receipt Notices) upload and scan" />
    </div>
  );
};

const Feature = (props: { description: string }) => {
  return (
    <div
      css={`
        display: flex;
        align-items: center;
        gap: 10px;
      `}
    >
      <div>
        <div
          css={`
            border-radius: 12px;
            width: 24px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #325aff;
          `}
        >
          <IconCheck
            css={`
              fill: white;
            `}
          />
        </div>
      </div>
      <div
        css={`
          line-height: 24px;
          font-size: 14px;
          font-weight: 500;
          font-family: "Pretendard", sans-serif;

          @media (min-width: 960px) {
            line-height: 28px;
            font-size: 16px;
            font-weight: 600;
          }
        `}
      >
        {props.description}
      </div>
    </div>
  );
};
